var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCampingSquirrel = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.5,
    cy: 42.4826,
    rx: 42.5,
    ry: 42.4826,
    fill: "#A3BA8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0103 47.6823C28.8791 46.7093 31.8107 50.4549 32.2929 52.4494C35.6151 60.8299 35.9894 70.339 35.1373 75.4851C28.4341 75.821 31.1386 76.5374 25.7773 76.8061C24.4368 76.8733 23.7054 69.7299 16.9688 70.0918C12.5749 70.3279 9.2351 67.8267 8.20098 63.8375C7.16686 59.8484 11.1743 48.8987 21.0103 47.6823Z",
    fill: "#875202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.634 60.1646C37.0671 59.5303 24.5253 76.0228 22.2778 78.798C33.3831 87.1236 58.37 87.52 69.8719 74.0406C67.3335 69.9174 58.0614 58.8431 55.1529 58.9752C57.3739 52.632 63.614 48.4031 66.6548 46.6851L36.5118 51.4426C43.4923 53.6627 46.1629 57.6537 45.634 60.1646Z",
    fill: "#533200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7525 18.9333C34.6081 19.2505 36.6441 21.1799 37.3051 22.105L34.5288 26.8624C32.5457 27.3911 28.5795 27.7347 28.5795 24.8802C28.5795 22.0257 27.5219 20.2549 26.9931 19.7263C27.3897 19.3298 28.8968 18.6162 31.7525 18.9333Z",
    fill: "#533200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2751 11.7971C61.1022 12.4314 59.2513 15.7616 58.7225 17.3474L61.4988 20.1226C62.4242 19.594 64.4338 18.0611 65.0683 16.1581C65.7029 14.2551 64.8039 12.4578 64.2751 11.7971Z",
    fill: "#533200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7726 20.3378C31.4869 23.8878 30.1655 34.7261 30.1655 39.7015C38.094 44.5424 57.6952 40.3739 67.3306 37.6845C67.3306 35.5329 68.5694 32.0367 68.1565 27.1958C67.8767 23.916 62.9258 18.8587 60.7234 16.7071C56.181 14.6901 43.3797 15.9003 36.7726 20.3378Z",
    fill: "#533200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.098 22.5013C33.6559 25.9901 32.0165 36.3772 31.7521 41.1347C41.9055 42.7205 48.41 39.1524 50.3931 37.1701C47.2202 23.5321 40.8743 21.7084 38.098 22.5013Z",
    fill: "#875202"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5153 26.4659C59.5153 29.3204 62.9527 33.47 64.6714 35.1879C66.2578 34.395 70.224 33.6021 68.6375 28.0517C67.3684 23.6114 63.3493 19.3297 61.4984 17.7439C59.912 18.5368 59.5153 22.8978 59.5153 26.4659Z",
    fill: "#875202"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0807 38.756C41.6672 38.756 46.8232 37.9631 49.203 37.5667C51.7149 37.3024 57.294 36.5359 59.515 35.5844C62.2913 34.395 69.0338 32.8092 70.6203 33.9986C72.2068 35.1879 73 36.3773 73 39.1525C73 41.9277 69.8271 45.0993 67.0507 46.6851C64.2744 48.271 61.4981 48.271 60.3082 48.271C59.3564 48.271 58.0607 49.3282 57.5319 49.8568C51.186 53.8213 49.9962 53.4249 40.874 52.632C31.7518 51.8391 28.5788 47.0816 27.7856 44.3064C26.9924 41.5312 28.1822 39.1525 30.1653 38.3596C32.1484 37.5667 38.0977 38.756 40.0807 38.756Z",
    fill: "#533200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3197 50.5416C61.957 48.4656 62.0669 44.1983 61.7922 42.3241C60.8032 43.3621 56.1603 43.9099 53.9625 44.0541C53.9625 44.9191 56.023 53.1366 59.3197 50.5416Z",
    fill: "#F9F7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0132 37.9629C48.3305 36.3771 50.9217 35.5842 51.9793 35.5842C55.0201 35.1877 61.025 33.919 62.2942 33.6018C63.8807 33.2054 63.0991 44.9654 59.1214 45.4956C53.1722 46.2885 47.6166 39.9452 48.0132 37.9629Z",
    fill: "#875202"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1187 38.7959C59.7533 38.4788 61.234 35.4921 61.895 34.0385C57.4529 32.7698 53.1695 34.5671 51.583 35.6243C53.6983 36.6815 58.1668 38.7959 59.1187 38.7959Z",
    fill: "#2E1B00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.476 32.1105C45.5241 29.5732 43.5231 29.4788 41.3199 29.7318C38.2424 30.0852 36.1639 32.507 36.5605 36.0751C36.8778 38.9296 40.7176 39.5082 43.303 38.4538C45.8685 37.4077 47.4278 34.6478 46.476 32.1105Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6134 28.3161C68.8711 26.2016 66.0237 25.6731 64.6718 26.0695C63.4819 29.6376 65.7469 33.0148 67.4481 33.6021C69.0346 33.6021 70.3558 30.4305 69.6134 28.3161Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6681,
    cy: 34.7915,
    rx: 1.18985,
    ry: 1.18937,
    fill: "#C4C4C4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0512,
    cy: 29.2411,
    rx: 1.98309,
    ry: 1.98228,
    fill: "#2E1B00"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.0645,
    cy: 34.395,
    rx: 3.17294,
    ry: 3.17164,
    fill: "#2E1B00"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.8572,
    cy: 33.6021,
    rx: 0.793235,
    ry: 0.792911,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8443,
    cy: 28.4482,
    rx: 0.396618,
    ry: 0.396456,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7225 47.478V51.4426",
    stroke: "#533200",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7122 84.7449C41.7388 78.8317 46.6229 67.3142 50.8344 66.1114C55.8479 64.6796 61.9397 72.0582 64.3194 78.798C64.3194 78.798 61.5431 81.1768 54.404 83.159C47.2648 85.1413 41.7122 84.7449 41.7122 84.7449Z",
    fill: "#875202"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCampingSquirrel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CampingSquirrel.2dd4a11f6384a2cde94be30a1a0fba01.svg";